import { useState } from 'react';
import GalleryForm from './GalleryForm';
import GalleryList from './GalleryList';
import GalleryModal from '../../components/modals/GalleryModal';
import EditGalleryForm from './edit-gallery-form';

const GalleryTabs = () => {
  const [activeTab, setActiveTab] = useState('list');
  const [editGallery, setEditGallery] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleEdit = (gallery) => {
    setEditGallery(gallery);
    setModalOpen(true);
  };

  const handleFormClose = () => {
    setEditGallery(null);
    setModalOpen(false);
    setActiveTab('list');
  };

  return (
    <div className='gallery-tabs-container container-fluid'>
      <div className='tabs mb-4'>
        <button
          className={`tab-btn ${activeTab === 'list' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('list');
            setEditGallery(null);
          }}
        >
          All Galleries
        </button>
        <button
          className={`tab-btn ${activeTab === 'add' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('add');
            setEditGallery(null);
          }}
        >
          {editGallery ? 'Edit Gallery' : 'Add Gallery'}
        </button>
      </div>
      {activeTab === 'list' && <GalleryList onEdit={handleEdit} />}
      {activeTab === 'add' && !editGallery && (
        <GalleryForm editGallery={null} onClose={handleFormClose} />
      )}
      <GalleryModal isOpen={modalOpen} onRequestClose={handleFormClose}>
        <EditGalleryForm galleryData={editGallery} onClose={handleFormClose} />I
      </GalleryModal>
      <style jsx>{`
        .tabs {
          display: flex;
          gap: 12px;
        }
        .tab-btn {
          padding: 8px 24px;
          border: none;
          border-radius: 8px;
          background: #f1f5f9;
          color: #b91c1c;
          font-weight: 600;
          cursor: pointer;
        }
        .tab-btn.active {
          background: #b91c1c;
          color: #fff;
        }
      `}</style>
    </div>
  );
};

export default GalleryTabs;
